import { render, staticRenderFns } from "./wisdomTeaching.vue?vue&type=template&id=29631a0c&scoped=true"
import script from "./wisdomTeaching.vue?vue&type=script&lang=js"
export * from "./wisdomTeaching.vue?vue&type=script&lang=js"
import style0 from "./wisdomTeaching.vue?vue&type=style&index=0&id=29631a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29631a0c",
  null
  
)

export default component.exports